(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["peppi-desktop-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle',function(event){
  const opened=event.target;
  if(!opened.matches('[data-ppnav-root]')||!opened.open)return;
  const nav=opened.closest('.ppnav');
  nav.querySelectorAll('[data-ppnav-root][open]').forEach(function(other){if(other!==opened)other.open=false;});
},true);
document.addEventListener('click',function(event){
  document.querySelectorAll('.ppnav').forEach(function(nav){
    if(!nav.contains(event.target))nav.querySelectorAll('[data-ppnav-root][open]').forEach(function(item){item.open=false;});
  });
});
document.addEventListener('keydown',function(event){
  if(event.key!=='Escape')return;
  document.querySelectorAll('[data-ppnav-root][open]').forEach(function(item){item.open=false;item.querySelector('summary').focus();});
});
  } catch(e) { console.error(e); }
})();

})();
